export { default } from './data'
